const SITES_PENDING = 'sites_pending';
const SITES_FAILED = 'sites_failed';
const SITES_DOWNLOADED = 'sites_downloaded';
const SITES_RESET = 'sites_reset';
const SITE_SENDING = 'site_sending';
const SITE_DOWNLOADED = 'site_downloaded';

export {
  SITES_PENDING,
  SITES_FAILED,
  SITES_DOWNLOADED,
  SITES_RESET,
  SITE_SENDING,
  SITE_DOWNLOADED,
};



// WEBPACK FOOTER //
// ./src/store/sites/types.js